import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import Layout from './components/Layout.vue'
import axios from 'axios'

Vue.prototype.$axios = axios
Vue.use(ElementUI)

new Vue({
  el: '#app',
  router,
  render: h => h(Layout)
})

router.afterEach((to, from, next) => {
  window.scrollTo(0,0)
})

router.afterEach((to, from, next) => {
  document.body.scrollTop =0
  document.documentElement.scrollTop = 0
})
